var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArSmlRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BoostAutorechargeIcon32x32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BoostAutorechargeIcon32x32",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Boost_icon_pack_autorecharge_icon_1_small_OR_50",
    transform: "translate(4.000000, 0.000000)",
    fill: "#FF4300",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.7736,5.9184 C22.7736,10.5336 22.7736,10.8896 22.7736,15.2456 C22.7736,15.5264 22.7736,15.8072 22.7232,16.1528 L20.2104,16.1528 C20.2104,15.7424 20.1528,15.3104 20.1528,14.8712 C20.1528,11.8256 20.1528,12.78 20.1528,9.7344 C20.1528,8.8848 19.908,8.5896 19.0368,8.604 C16.0848,8.6544 8.0208,8.604 4.7664,8.604 L9.1656,12.5352 L7.1208,14.4 L0,7.2 L7.1424,0 L8.7624,1.9728 C7.5312,3.0528 6.156,4.6944 4.7736,5.9112 L22.7736,5.9112 L22.7736,5.9184 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.3176,26.1536 C1.3176,21.5312 1.3176,21.1752 1.3176,16.8192 C1.3176,16.5384 1.3176,16.2576 1.368,15.912 L3.8736,15.912 C3.8736,16.3224 3.9312,16.7616 3.9312,17.1936 C3.9312,20.2392 3.9312,19.2848 3.9312,22.3304 C3.9312,23.18 4.176,23.4752 5.0472,23.4608 C7.9992,23.4176 16.0632,23.4608 19.3176,23.4608 L14.9256,19.5368 L16.9416,17.7008 L24.0624,24.8504 L17.0208,32 C16.4952,31.4168 16.02,30.8624 15.3288,30.092 C16.56,29.012 17.9352,27.3704 19.3176,26.1608 L1.3176,26.1608 L1.3176,26.1536 Z",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArSmlRed);
export default __webpack_public_path__ + "static/media/AR_Sml-red.030a59580190ce7a7a80cde45c964e8f.svg";
export { ForwardRef as ReactComponent };